<template>
  <div class="rb-step-help">
    <a href="#" v-if="showHelpTitle">{{ helpTitle }}</a>
    <button
      class="rb-btn-help"
      :aria-label="`About ${label}`"
      @click.prevent="notifyPopup($event, popupId)"
      :id="`popup-open-${popupId}`"
    >
      <div>i</div>
    </button>
  </div>
</template>
<script>
/**
 * Displays a button to open step static popups
 *
 * @props
 * popupId: String
 * showLabel: Boolean
 * label: String
 * showHelpTitle: Boolean
 * helpTitle: String
 *
 * @implements
 * CommMixin
 * TrackMixin
 *
 * @emits
 * rb-open-popup
 */
import TrackMixin from "@/mixins/TrackMixin";
import CommMixin from "@/mixins/CommMixin";
export default {
  mixins: [CommMixin, TrackMixin],
  props: {
    popupId: {
      type: String,
      default: "",
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    showHelpTitle: {
      type: Boolean,
      default: false,
    },
    helpTitle: {
      type: String,
      default: "",
    },
  },
  methods: {
    notifyPopup: function (event, id) {
      this.trackEvent(
        this.formatTracking(this.getTrackId(event), this.TRACK_CLICK),
        this.getTrackId(event)
      );
      this.broadcast("rb-open-popup", { id });
    },
  },
};
</script>
